import React, { useRef } from 'react'

import { isUndefined } from '../../utils/locDash'
import Box from '../Box'

import { StyledInput } from './styled'

import { UploadProps } from './Upload.types'

const Upload: React.FC<UploadProps> = ({ children, onRequest, onChange, ...inputProps }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isUndefined(onRequest)) {
      return onChange(event)
    }

    return onRequest(event)
  }
  const inputRef = useRef(null)

  return (
    <Box
      onClick={() => {
        inputRef?.current?.click()
      }}
    >
      {children}
      <StyledInput ref={inputRef} {...inputProps} onChange={handleChange} />
    </Box>
  )
}

export default Upload
